import { Routes, Route } from "react-router-dom";
import Login from "../pages/accounts/Login";
import Dashboard from "../pages/accounts/dashboard";
import Farms from "../pages/farms/farms";
import FarmsView from "../pages/farms/farms-view";
import FarmsEdit from "../pages/farms/farms-edit";
import FarmAdd from "../pages/farms/farms-Add";
import FarmsProfile from "../pages/farms-profile/farms-profile";
import FarmsProfileView from "../pages/farms-profile/farms-profile-view";
import FarmsProfileEdit from "../pages/farms-profile/farms-profile-edit";
import ProjectGrantee from "../pages/project-grantee/project-grantee";
import ProjectGranteeView from "../pages/project-grantee/project-grantee-view";
import ProjectGranteeEdit from "../pages/project-grantee/project-grantee-edit";
import Producers from "../pages/producers/producers";
import ProducersEdit from "../pages/producers/producers-edit";
import ProducersView from "../pages/producers/producers-view";
import Partner from "../pages/partner/partner";
import PartnerView from "../pages/partner/partner-view";
import PartnerEdit from "../pages/partner/partner-edit";
import FarmsProfileAdd from "../pages/farms-profile/farms-profile-add";
import Contacts from "../pages/contacts/contacts";
import PoketProfile from "../pages/poket-profile/poket-profile";
import PocketProfileView from "../pages/poket-profile/poket-profile-view";
import ContactsView from "../pages/contacts/contacts-view";
import ContactsEdit from "../pages/contacts/contacts-edit";
import ContactsAdd from "../pages/contacts/contacts-add";

import Soil from "../pages/soil/soil";
import SoilView from "../pages/soil/soil-view";

import Invoice from "../pages/invoice/invoice";
import InvoiceEdit from "../pages/invoice/invoice-edit";
import InvoiceView from "../pages/invoice/invoice-view";

import Summary from "../pages/summary/summary";
import SummaryView from "../pages/summary/summary-view";

import Management from "../pages/management/management";
import ManagementView from "../pages/management/management-view";

import Community from "../pages/community/community";
import CommunityView from "../pages/community/community-view";

import Accessibility from "../pages/accessibility/accessibility";
import AccessibilityView from "../pages/accessibility/accessibility-view";

import Vendors from "../pages/vendors/vendors";
import VendorsView from "../pages/vendors/vendors-view";

export default function Root() {
  return (
    <>
      <Routes>
        <Route path="" element={<Login />} />
        <Route path="login" element={<Login />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="farms" element={<Farms />} />
        <Route path="farms/view" element={<FarmsView />} />
        <Route path="farms/edit" element={<FarmsEdit />} />
        <Route path="farms/add" element={<FarmAdd />} />
        <Route path="farms-profile" element={<FarmsProfile />} />
        <Route path="farms-profile/view" element={<FarmsProfileView />} />
        <Route path="farms-profile/edit" element={<FarmsProfileEdit />} />
        <Route path="farms-profile/add" element={<FarmsProfileAdd />} />
        <Route path="farms/edit/:FarmId/*" element={<FarmsEdit />} />
        <Route path="farms/view/:FarmId/*" element={<FarmsView />} />
        <Route
          path="farms-profile/view/:FarmId/*"
          element={<FarmsProfileView />}
        />
        <Route
          path="farms-profile/edit/:FarmId/*"
          element={<FarmsProfileEdit />}
        />

        <Route path="project-grantee" element={<ProjectGrantee />} />
        <Route path="project-grantee/view" element={<ProjectGranteeView />} />
        <Route path="project-grantee/edit" element={<ProjectGranteeEdit />} />
        <Route path="producers" element={<Producers />} />
        <Route path="producers/view" element={<ProducersView />} />
        <Route path="producers/edit" element={<ProducersEdit />} />

        <Route path="partner" element={<Partner />} />
        <Route path="partner/view" element={<PartnerView />} />
        <Route path="partner/edit" element={<PartnerEdit />} />

        <Route path="Contacts" element={<Contacts />} />
        <Route path="Contacts/view/:id/*" element={<ContactsView />} />
        <Route path="Contacts/edit/:id/*" element={<ContactsEdit />} />
        <Route path="Contacts/add" element={<ContactsAdd />} />

        <Route path="PoketProfile" element={<PoketProfile />} />
        <Route path="PoketProfile/view/:id/*" element={<PocketProfileView />} />

        <Route path="Soil" element={<Soil />} />
        <Route
          path="/Soil/view/:farm_id/:treat_id/:point_id"
          element={<SoilView />}
        />
        <Route path="/Soil/view/:farm_id" element={<SoilView />} />
        <Route path="/Soil/view/:farm_id/:treat_id" element={<SoilView />} />

        <Route path="Invoice" element={<Invoice />} />
        <Route path="/Invoice/view/" element={<InvoiceView />} />
        <Route path="/Invoice/edit/" element={<InvoiceEdit />} />
        <Route path="/Invoice/view/:invoiceid" element={<InvoiceView />} />
        <Route path="/Invoice/edit/:invoiceid" element={<InvoiceEdit />} />

        <Route path="Summary" element={<Summary />} />
        {/* <Route path="/Summary/edit/" element={<SummaryEdit />} /> */}
        <Route path="/Summary/view/:summaryid" element={<SummaryView />} />

        <Route path="Management" element={<Management />} />
        <Route path="/Management/view/:mgtid" element={<ManagementView />} />

        <Route path="Community" element={<Community />} />
        <Route path="/Community/view/:communityid" element={<CommunityView />} />

        <Route path="Accessibility" element={<Accessibility />} />
        <Route path="/Accessibility/view/:accessibilityid" element={<AccessibilityView />} />

        <Route path="Vendors" element={<Vendors />} />
        <Route path="/Vendors/view/:vendorid" element={<VendorsView />} />
      </Routes>
    </>
  );
}
